export const SEARCH_BY_REG_REQUEST = 'SEARCH_BY_REG_REQUEST';
export const SEARCH_BY_REG_REQUEST_SUCCESS = 'SEARCH_BY_REG_REQUEST_SUCCESS';
export const SEARCH_BY_REG_REQUEST_FAILURE = 'SEARCH_BY_REG_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/constants/search_by_reg.constants.js